<template>
    <div class="product-popup">
        <div class="catalog-notification">
            <CartNotification :messages="messages"/>
        </div>
        <div class="product-popup__wrapper">
            <div class="product-popup__inner">
                <button
                    @click="closePopup" 
                    type="button" 
                    class="close"></button>
                <div class="product-popup__photos photos">
                    <img
                        class="photos__main" 
                        :src="'https://lenbuket.ru:8443/' + product_data.url">
                    <div class="photos__additioanl">
                        <img
                            class="photos__sub" 
                            :src="'https://lenbuket.ru:8443/' + product_data.url">
                        <img
                            v-if="product_data.url1"
                            class="photos__sub" 
                            :src="'https://lenbuket.ru:8443/' + product_data.url1">
                        <img
                            v-if="product_data.url2"
                            class="photos__sub" 
                            :src="'https://lenbuket.ru:8443/' + product_data.url2">
                        <img
                            v-if="product_data.url3"
                            class="photos__sub" 
                            :src="'https://lenbuket.ru:8443/' + product_data.url3">
                    </div>
                </div>
                <!-- Контент -->
                <div class="product-popup__content content">
                    <h1 class="content__name">{{product_data.name}}</h1>
                    <p 
                        :class="{showAllStructure: isShowAllComment}"
                        class="content__structure"><span class="content__structure_bold">Состав:</span> {{product_data.structure}}</p>
                    <button 
                        v-if="isCommentOverflow"
                        type="button" 
                        @click="showAllDescription"
                        :class="{rotateArrow: isShowAllComment}"
                        class="product-content__show">Читать полностью</button>

                    <p class="content__price">{{product_data.price}} р</p>

                    <div class="cart-item__controlls-wrapper">
                        <span class="cart-item__qty-text">Количество:</span>
                        <div class="controlls cart-item__controlls">
                            <button class="controlls__decrease controlls__btn" @click="quantityDecrease">
                            </button>
                            
                            <output class="controlls__output">{{ product_data.quantity }}</output>

                            <button class="controlls__increase controlls__btn" @click="quantityIncrease">
                            </button>
                        </div>
                    </div>
                    <button 
                        type="button" 
                        class="content__btn"
                        @click="addToCart">В корзину</button>
                </div>
            </div>
            <AdditionalProds class="product-popup__additional"/>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import AdditionalProds from '@/components/Additional-prods'
import CartNotification from '@/components/Cart-notification';

export default {
    props: {
        product_data: {
            type: Object,
            default(){
                return{

                }
            }
        }
    },
    data() {
        return {
            messages: [],
            isShowAllComment: false
            // product_data: {
            //     id: 1,
            //     name: 'Букет “Лилово-розовый”',
            //     price: 4000,
            //     structure: 'гортензия, пионовидная роза 5шт, гвоздика 5шт, маттиола 3шт, фисташка, упаковка, лента',
            //     url: 'mok-photo.png',
            //     quantity: 1
            // }
        }
    },
    computed: {
        isCommentOverflow(){
            return this.product_data.structure.length > 125 ? true : false
        },
    },
    components: {
        AdditionalProds,
        CartNotification
    },
    methods: {
        ...mapActions([
            'INCREASE_QTY',
            'DECREASE_QTY',
            'ADD_TO_CART'
        ]),
        closePopup(){
            this.$emit('closePopup')
        },
        quantityDecrease(){
            if (this.product_data.quantity > 0) {
                this.product_data.quantity--
            }
        },
        quantityIncrease(){
            this.product_data.quantity++
        },
        showAllDescription(){
            this.isShowAllComment = !this.isShowAllComment
        },
        addToCart(){
            this.isAddedInCart = true
            let timeStamp = Date.now().toLocaleString()
            this.messages.unshift(
                {name: "Товар добавлен в корзину", id: timeStamp}
            )
            this.ADD_TO_CART(this.product_data)
        },
    },
    

}
</script>

<style scoped>
    .product-popup{
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, .5);
        top: 0;
        left: 0;
        padding-left: 15px;
        padding-right: 15px;
        z-index: 10000;
    }
    .product-popup__wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 1200px;
        background-color: #ECDED3;
        border-radius: 20px;
        padding: 100px 60px;
        overflow-y: scroll;
        height: 80vh;
    }
    .product-popup__inner{
        position: relative;
        display: flex;
        margin-bottom: 40px;
    }
    .product-popup__content{
        display: flex;
        flex-direction: column;
    }
    .product-popup__photos{
        display: flex;
        flex-direction: column;
        margin-right: 20px;
    }
    .photos__main{
        max-width: 420px;
        aspect-ratio: 1/1;
        border-radius: 10px;
        margin-bottom: 20px;
    }
    .photos__additioanl{
        display: flex;
        width: 100%;
    }
    .photos__sub{
        max-width: 80px;
        aspect-ratio: 1/1;
        border-radius: 10px;
        margin-right: 20px;
    }
    .photos__sub:last-child{
        margin-right: 0;
    }
    .content{
        color: #3A3841;
    }
    .content__name{
        font-weight: 400;
        font-family: 'Romul';
        margin-bottom: 20px;
        font-size: 24px;
    }
    .content__structure{
        font-size: 20px;
        margin-bottom: 20px;
        max-width: 450px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .content__structure_bold{
        font-weight: 700;
    }
    .content__price{
        font-size: 30px;
        margin-bottom: 40px;
    }
    .content__btn{
        font-size: 20px;
        font-family: 'Bona Nova';
        text-decoration: underline;
    }
    .content__btn:hover{
        text-decoration: none;
    }
    /*  */
    .cart-item__controlls-wrapper{
        display: flex;
        align-items: center;
        margin-bottom: 40px;
    }
    .cart-item__qty-text{
        font-size: 20px;
        color: #3A3841;
        margin-right: 10px;
    }
    .cart-item__controlls{
        display: flex;
        align-items: center;
        align-self: flex-end;
        justify-content: space-between;
        height: 40px;
        width: 100%;
        max-width: 125px;
    }
    .controlls__btn{
        position: relative;
        height: 100%;
        width: 100%;
        max-width: 40px;
        transition: all linear .2s;
        border-radius: 5px;
    }
    .controlls__btn:hover{
        cursor: pointer;
    }
    .controlls__decrease:hover{
        background-color: #b9aea6;
    }
    .controlls__decrease::before{
        position: absolute;
        content: "";
        height: 1px;
        width: 18px;
        top: 50%;
        left: 50%;
        margin-left: -9px;
        background-color: #000;
    }
    .controlls__increase:hover{
        background-color: #b9aea6;
    }
    .controlls__increase::before{
        position: absolute;
        content: "";
        height: 1px;
        width: 18px;
        top: 50%;
        left: 50%;
        margin-left: -9px;
        background-color: #000;
    }
    .controlls__increase::after{
        position: absolute;
        content: "";
        height: 1px;
        width: 18px;
        top: 50%;
        left: 50%;
        margin-left: -9px;
        transform: rotate(90deg);
        background-color: #000;
    }
    .controlls__output{
        display: inline-block;
        font-size: 20px;
        margin: 0 10px;
    }
    .showAllStructure{
        -webkit-line-clamp: inherit;
    }
    .product-content__show{
        position: relative;
        margin-top: 10px;
        margin-left: auto;
        padding-right: 20px;
        text-decoration: underline;
        font-size: 16px;
        margin-bottom: 25px;
    }
    .product-content__show:hover{
        text-decoration: none;
    }
    .product-content__show::after{
        position: absolute;
        content: "";
        height: 10px;
        width: 10px;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        transform: rotate(45deg);
        right: 0;
        top: 50%;
        margin-top: -7px;
        transition: all linear .2s ;
    }
    .rotateArrow::after{
        transform: rotate(-135deg);
    }
    @media (max-width: 768px) {
        .product-popup__content{
            display: block;
        }
        .close{
            top: -40px;
        }
        .product-popup__wrapper{
            padding: 65px 25px;
        }
        .product-popup__inner{
            flex-direction: column;
        }
        .product-popup__photos{
            margin-right: 0;
            margin-bottom: 25px;
        }
        .photos__main{
            max-width: none;
        }
    }
    @media (max-width: 600px){
        .product-popup__inner{
            margin-bottom: 50px;
        }
        .product-popup__content{
            flex-direction: column-reverse;
        }
        .content__name{
            font-size: 16px;
            margin-bottom: 15px;
        }
        .content__structure{
            font-size: 16px;
            margin-bottom: 15px;
        }
        .content__price{
            font-family: 'Romul';
            font-size: 16px;
            margin-bottom: 15px;
        }
        .cart-item__qty-text{
            font-size: 16px;
        }
        .cart-item__controlls-wrapper{
            margin-bottom: 15px;
        }
        .content__btn{
            font-size: 16px;
        }
    }
</style>